import { useEffect, useState } from "react";
import { VenueSettingsItemApi } from "../../../../../../../../../../../services/Api/types";

const useCollapseCard = (search?: string, types?: VenueSettingsItemApi[], resultFound?: boolean) => {
	const [collapseIn, setCollapseIn] = useState(false);

	const toggleCollapse = () => setCollapseIn((prevCollapse) => !prevCollapse);

	useEffect(() => {
		if (types && search) {
			if (search.length > 0 && !collapseIn && types.length > 0) setCollapseIn(true);
			if (types.length === 0 && collapseIn) setCollapseIn(false);
		} else if (search && search.length > 0 && resultFound) {
			setCollapseIn(true);
		} else if (resultFound === false) {
			setCollapseIn(false);
		} else if (!search) {
			setCollapseIn(false);
		}
	}, [search, resultFound, types?.length]);

	const getCollapseIconStyles = () => {
		return { transform: collapseIn ? "rotate(180deg)" : "" };
	};

	return {
		toggleCollapse,
		collapseIn,
		getCollapseIconStyles,
	};
};

export default useCollapseCard;
